import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  Box,
  Table,
  AspectRatio,
  Card,
  CardContent,
  Divider,
  ButtonGroup,
  Button,
  Sheet,
  Modal,
  ModalOverflow,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
} from "@mui/joy";
import { toast } from "react-toastify";
import {
  LoadingView,
  Main,
  MapContainer,
  PageTitle,
} from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { FILE_BASE, STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import { useMediaQuery } from "@mui/material";
import {
  deactivateStaffRequest,
  activateStaffRequest,
  deactivateStaffReset,
  activateStaffReset,
  viewStaffReset,
  viewStaffRequest,
  rejectStaffRequest,
  rejectStaffReset,
  approveStaffRequest,
  approveStaffReset,
  editStaffRequest,
  editStaffReset,
  unblockStaffRequest,
  unblockStaffReset,
  resetStaffPasswordRequest,
  resetStaffPasswordReset,
} from "../../../store/actions";
import {
  BlockOutlined,
  CheckCircle,
  DoNotDisturbOn,
  EditOutlined,
  LockOpenOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const StaffViewPage = ({
  loginResult,

  editStaffStatus,
  editStaffResult,
  editStaffErrorMessage,

  viewStaffStatus,
  viewStaffResult,
  viewStaffErrorMessage,

  rejectStaffStatus,
  rejectStaffResult,
  rejectStaffErrorMessage,

  approveStaffStatus,
  approveStaffResult,
  approveStaffErrorMessage,

  activateStaffStatus,
  activateStaffResult,
  activateStaffErrorMessage,

  deactivateStaffStatus,
  deactivateStaffResult,
  deactivateStaffErrorMessage,

  resetStaffPasswordStatus,
  resetStaffPasswordResult,
  resetStaffPasswordErrorMessage,

  unblockStaffStatus,
  unblockStaffResult,
  unblockStaffErrorMessage,
}) => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { staff_id } = state;

  const [formModal, setFormModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const [fname, setFName] = useState("");
  const [sname, setSName] = useState("");
  const [lname, setLName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState(0);

  useEffect(() => {
    if (viewStaffStatus === STATUS.SUCCESS) {
      setFName(viewStaffResult.first_name);
      setSName(viewStaffResult.middle_name);
      setLName(viewStaffResult.last_name);
      setEmail(viewStaffResult.email);
      setMobile(viewStaffResult.mobile_num);
      setRole(viewStaffResult.role.toString());
      setStatus(viewStaffResult.status);
      setRemark(viewStaffResult.remark);
      setTimeout(() => {
        dispatch(viewStaffReset());
      }, 2000);
    }

    if (editStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff edited successful");
      setFormModal(false);
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(editStaffReset());
    } else if (editStaffStatus === STATUS.ERROR) {
      toast.error(editStaffErrorMessage);
      dispatch(editStaffReset());
    }

    if (approveStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff approved successful");
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(approveStaffReset());
    } else if (approveStaffStatus === STATUS.ERROR) {
      toast.error(approveStaffErrorMessage);
      dispatch(approveStaffReset());
    }

    if (rejectStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff rejected successful");
      setRejectModal(false);
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(rejectStaffReset());
    } else if (rejectStaffStatus === STATUS.ERROR) {
      toast.error(rejectStaffErrorMessage);
      dispatch(rejectStaffReset());
    }

    if (activateStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff activated successful");
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(activateStaffReset());
    } else if (activateStaffStatus === STATUS.ERROR) {
      toast.error(activateStaffErrorMessage);
      dispatch(activateStaffReset());
    }

    if (deactivateStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff deactivated successful");
      setDeactivateModal(false);
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(deactivateStaffReset());
    } else if (deactivateStaffStatus === STATUS.ERROR) {
      toast.error(deactivateStaffErrorMessage);
      dispatch(deactivateStaffReset());
    }

    if (resetStaffPasswordStatus === STATUS.SUCCESS) {
      toast.success("Staff user password reset successful");
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(resetStaffPasswordReset());
    } else if (resetStaffPasswordStatus === STATUS.ERROR) {
      toast.error(resetStaffPasswordErrorMessage);
      dispatch(resetStaffPasswordReset());
    }

    if (unblockStaffStatus === STATUS.SUCCESS) {
      toast.success("Staff user unblocked  successful");
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
      dispatch(unblockStaffReset());
    } else if (unblockStaffStatus === STATUS.ERROR) {
      toast.error(unblockStaffErrorMessage);
      dispatch(unblockStaffReset());
    }
  });

  useEffect(() => {
    if (staff_id != "") {
      dispatch(viewStaffRequest(loginResult.token, { id: staff_id }));
    }
  }, []);

  const handleRoleSelection = (event, newValue) => {
    setRole(newValue);
  };

  const submitEditForm = (event) => {
    event.preventDefault();
    if (fname && sname && lname && email && mobile) {
      const data = {
        id: staff_id,
        first_name: fname,
        middle_name: sname,
        last_name: lname,
        email: email,
        mobile_num: mobile,
        role: role,
      };
      dispatch(editStaffRequest(loginResult.token, data));
    } else {
      toast.error("Please fill all required information");
    }
  };

  // ------ actions -------------------------
  const approveStaff = () => {
    const data = {
      id: staff_id,
    };
    dispatch(approveStaffRequest(loginResult.token, data));
  };

  const rejectStaff = (event) => {
    event.preventDefault();
    const data = {
      id: staff_id,
      remark: remark,
    };
    dispatch(rejectStaffRequest(loginResult.token, data));
  };

  const activateStaff = () => {
    const data = {
      id: staff_id,
    };
    dispatch(activateStaffRequest(loginResult.token, data));
  };

  const deactivateStaff = (event) => {
    event.preventDefault();
    const data = {
      id: staff_id,
      remark: remark,
    };
    dispatch(deactivateStaffRequest(loginResult.token, data));
  };

  const resetStaffPassword = () => {
    const data = {
      id: staff_id,
    };
    dispatch(resetStaffPasswordRequest(loginResult.token, data));
  };

  const unblockStaff = () => {
    const data = {
      id: staff_id,
    };
    dispatch(unblockStaffRequest(loginResult.token, data));
  };

  const checkLoading = () => {
    if (
      viewStaffStatus === STATUS.LOADING ||
      editStaffStatus === STATUS.LOADING ||
      approveStaffStatus === STATUS.LOADING ||
      rejectStaffStatus === STATUS.LOADING ||
      activateStaffStatus === STATUS.LOADING ||
      deactivateStaffStatus === STATUS.LOADING ||
      unblockStaffStatus === STATUS.LOADING ||
      resetStaffPasswordStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("First Name", fname),
    CreateItems("Second Name", sname),
    CreateItems("Last Name", lname),
    CreateItems(
      "Role",
      {
        1: "Admin",
        2: "Manager",
        3: "Sale Officer",
        4: "Quality Assurance Personnel",
      }[role],
    ),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Locked", 4: "Rejected", 5: "Pending" }[
        status
      ],
    ),
    CreateItems("Email", email),
    CreateItems("Mobile", mobile),
    CreateItems("Remark", remark),
  ];

  return (
    <Box>
      <PageTitle title={`${fname} Details`} />

      <LoadingView loading={checkLoading()} />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Action Button */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* ---- only admin can do this actions ------ */}
          {loginResult.role === 1 &&
            status != 4 &&
            (status === 5 ? (
              <>
                <Button
                  color="success"
                  startDecorator={<TaskAltOutlined />}
                  onClick={approveStaff}
                >
                  Approve
                </Button>
                <Button
                  color="warning"
                  startDecorator={<BlockOutlined />}
                  onClick={() => setRejectModal(true)}
                >
                  Reject
                </Button>
              </>
            ) : status === 1 ? (
              <>
                <Button
                  color="danger"
                  startDecorator={<DoNotDisturbOn />}
                  onClick={() => setDeactivateModal(true)}
                >
                  Deactivate
                </Button>

                <Button
                  color="primary"
                  startDecorator={<EditOutlined />}
                  onClick={() => setFormModal(true)}
                >
                  Edit
                </Button>

                <Button
                  color="neutral"
                  // startDecorator={<EditOutlined />}
                  onClick={resetStaffPassword}
                >
                  Reset Password
                </Button>
              </>
            ) : status === 3 ? (
              <Button
                color="danger"
                startDecorator={<LockOpenOutlined />}
                onClick={unblockStaff}
              >
                UnLock
              </Button>
            ) : (
              <Button
                color="success"
                startDecorator={<CheckCircle />}
                onClick={activateStaff}
              >
                Activate
              </Button>
            ))}
        </Box>

        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* client details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>Staff Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Sheet>
        </Box>
      </Box>

      {/* ------ Modal form for add and edit staff details ------ */}
      <Modal open={formModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              top: "60px",
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose variant="outlined" onClick={() => setFormModal(false)} />
          <DialogTitle>{"Edit staff " + fname}</DialogTitle>
          <DialogContent>Please enter staff details correct.</DialogContent>
          <Stack
            component="form"
            onSubmit={submitEditForm}
            gap={2}
            sx={{ mt: 2 }}
          >
            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* first name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>First Name</FormLabel>
                <Input
                  type="text"
                  value={fname}
                  onChange={(e) => setFName(e.target.value)}
                  placeholder="Enter your first name"
                />
              </FormControl>

              {/* second name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Middle Name</FormLabel>
                <Input
                  type="text"
                  value={sname}
                  onChange={(e) => setSName(e.target.value)}
                  placeholder="Enter your second name"
                />
              </FormControl>

              {/* last name */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Last Name</FormLabel>
                <Input
                  type="text"
                  value={lname}
                  onChange={(e) => setLName(e.target.value)}
                  placeholder="Enter your third name"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* mobile number */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Mobile number</FormLabel>
                <Input
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="Enter staff phone number"
                />
              </FormControl>

              {/* email */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter staff email"
                />
              </FormControl>
            </Stack>

            <Stack direction={{ xs: "column", md: "row" }} gap={2}>
              {/* role */}
              <FormControl sx={{ flex: 1 }} required>
                <FormLabel>Role</FormLabel>
                <Select
                  placeholder="Select staff ownership"
                  value={role}
                  onChange={handleRoleSelection}
                  required
                >
                  <Option value="1">Admin</Option>
                  <Option value="2">Manager</Option>
                  <Option value="3">Sales Officer</Option>
                  <Option value="4">Quality Assurance Personnel</Option>
                </Select>
              </FormControl>
            </Stack>

            <Stack gap={4} sx={{ mt: 2 }}>
              <Button type="submit" fullWidth>
                Submit
              </Button>
            </Stack>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* reject modal */}
      <Modal open={rejectModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setRejectModal(false)}
          />
          <DialogTitle>{"Reject staff:" + fname}</DialogTitle>
          <DialogContent>Please write a reason for rejection.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={rejectStaff}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Rejection reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              REJECT
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate staff staff:" + fname}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivateStaff}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ staff, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    editStaffStatus,
    editStaffResult,
    editStaffErrorMessage,

    viewStaffStatus,
    viewStaffResult,
    viewStaffErrorMessage,

    rejectStaffStatus,
    rejectStaffResult,
    rejectStaffErrorMessage,

    approveStaffStatus,
    approveStaffResult,
    approveStaffErrorMessage,

    activateStaffStatus,
    activateStaffResult,
    activateStaffErrorMessage,

    deactivateStaffStatus,
    deactivateStaffResult,
    deactivateStaffErrorMessage,

    resetStaffPasswordStatus,
    resetStaffPasswordResult,
    resetStaffPasswordErrorMessage,

    unblockStaffStatus,
    unblockStaffResult,
    unblockStaffErrorMessage,
  } = staff;

  return {
    loginResult,

    editStaffStatus,
    editStaffResult,
    editStaffErrorMessage,

    viewStaffStatus,
    viewStaffResult,
    viewStaffErrorMessage,

    rejectStaffStatus,
    rejectStaffResult,
    rejectStaffErrorMessage,

    approveStaffStatus,
    approveStaffResult,
    approveStaffErrorMessage,

    activateStaffStatus,
    activateStaffResult,
    activateStaffErrorMessage,

    deactivateStaffStatus,
    deactivateStaffResult,
    deactivateStaffErrorMessage,

    resetStaffPasswordStatus,
    resetStaffPasswordResult,
    resetStaffPasswordErrorMessage,

    unblockStaffStatus,
    unblockStaffResult,
    unblockStaffErrorMessage,
  };
};

export default connect(mapStateToProps, {})(StaffViewPage);
